import { Component, ElementRef, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, PageEvent } from "@angular/material";
import { NotificacaoService } from "../../services/notificacao.service";
import { TermoAceiteService } from "../../core/services/termo-aceite.service";
import { CarregandoService } from "../../services/carregando.service";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { QueryFilterService } from "../../core/services/query-filter-service";
import { TermoAceiteModel } from "../../dominio/termo-aceite-model";
import { PaginatedModel } from "../../dominio/paginated-model";
import { PaginatorServiceV2 } from "../../core/services/paginator-service-v2";
import { TermoAceiteUsuarioModel } from "../../dominio/termo-aceite-usuario-model";
import { UtilitarioService } from "../../services/utilitario.service";

@Component({
  selector: 'app-termo-aceite-lista-modal',
  templateUrl: './termo-aceite-lista-modal.component.html',
  styleUrls: ['./termo-aceite-lista-modal.component.scss']
})
export class TermoAceiteListaModalComponent implements OnInit {

  termosAceite: TermoAceiteUsuarioModel[] = [];
  paginador: PaginatedModel;

  // 1 - Somente Aceitos | 2 - Todos
  tipoVisualizacao = 1;
  idUsuario;
  tipoUsuario;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<TermoAceiteListaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private termoAceiteService: TermoAceiteService,
    private carregandoService: CarregandoService,
    private queryFilterService: QueryFilterService,
    private paginatorServiceV2: PaginatorServiceV2,
    private utilitarioService: UtilitarioService,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {

    if (this.data !== null && this.data !== undefined) {
      if (this.data.tipoVisualizacao !== null && this.data.tipoVisualizacao !== undefined) {
        this.tipoVisualizacao = this.data.tipoVisualizacao;
      }

      if (this.data.idUsuario !== null && this.data.idUsuario !== undefined) {
        this.idUsuario = this.data.idUsuario;
      }

      if (this.data.tipoUsuario !== null && this.data.tipoUsuario !== undefined) {
        this.tipoUsuario = this.data.tipoUsuario;
      }
    }

    this.paginador = this.paginatorServiceV2.createInstance();

    this.buscarTermosAceite();
  }

  buscarTermosAceite() {
    this.carregandoService.mostra('buscarTermosAceite');

    const queryFilter = this.queryFilterService.getQueryBuilder()
      .setPage(this.paginador.page)
      .setPageSize(this.paginador.pageSize)
      .build();

    (this.tipoVisualizacao === 1 ? this.termoAceiteService.listarTermos(queryFilter) : this.termoAceiteService.buscarTodosTermos(this.tipoUsuario, this.idUsuario, queryFilter)).subscribe(data => {
      this.termosAceite = data.results;
      this.paginador = this.paginatorServiceV2.createInstance(data.pagination);
      this.carregandoService.esconde('buscarTermosAceite');
    }, (erro) => {
      this.carregandoService.esconde('buscarTermosAceite');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.paginador.page = pageEvent.pageIndex + 1;
    this.paginador.pageSize = this.paginatorServiceV2.setPageSize(pageEvent.pageSize);

    this.buscarTermosAceite();
  }

  visualizarTermo(id) {
    const termo = this.termosAceite.find(t => t.idTermoAceite == id);

    this.carregandoService.mostra('visualizaTermo');
    this.termoAceiteService.baixarArquivo(termo.idTermoAceite).subscribe(arq => {
      this.utilitarioService.openBlobModal(arq, termo.termoAceite.arquivo);
      this.carregandoService.esconde('visualizaTermo');
    }, (erro) => {
      this.carregandoService.esconde('visualizaTermo');
      this.notificacaoService.erro(erro);
    });
  }

  baixarArquivo(id) {
    const termo = this.termosAceite.find(t => t.idTermoAceite == id);

    this.carregandoService.mostra('baixarArquivo');
    this.termoAceiteService.baixarArquivo(termo.idTermoAceite).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, termo.termoAceite.arquivo);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
